import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useLanguage } from '../../../contexts/LanguageContext';

const EmptyState = ({ hasFilters, onClearFilters, onUpload }) => {
  const { t } = useLanguage();

  if (hasFilters) {
    return (
      <div className="flex flex-col items-center justify-center py-16 px-4">
        <div className="flex items-center justify-center w-20 h-20 bg-muted rounded-full mb-6">
          <Icon name="Search" size={40} className="text-muted-foreground" />
        </div>
        <h3 className="text-xl font-semibold text-foreground mb-2">{t('noDocumentsFound')}</h3>
        <p className="text-muted-foreground text-center max-w-md mb-6">
          {t('noDocumentsFoundDesc')}
        </p>
        <Button
          variant="outline"
          onClick={onClearFilters}
          iconName="X"
          iconPosition="left"
        >
          {t('clearFilters')}
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="flex items-center justify-center w-20 h-20 bg-accent/10 rounded-full mb-6">
        <Icon name="FileText" size={40} color="var(--color-accent)" />
      </div>
      <h3 className="text-xl font-semibold text-foreground mb-2">{t('noDocumentsYet')}</h3>
      <p className="text-muted-foreground text-center max-w-md mb-6">
        {t('noDocumentsYetDesc')}
      </p>
      <Button
        onClick={onUpload}
        iconName="Upload"
        iconPosition="left"
      >
        {t('uploadFirstDocument')}
      </Button>
    </div>
  );
};

export default EmptyState;